import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
const ErrorPage = ({ status = "403", title = "403", subTitle = "Sorry, you are not authorized to access this page." }) => {
    return (_jsx(_Fragment, { children: _jsx(Result, { status: status, title: title, subTitle: subTitle, extra: _jsx(Button, { type: "primary", children: _jsx(Link, { to: "/", children: "Back Home" }) }) }) }));
};
export default ErrorPage;
